import { render, staticRenderFns } from "./ExpenseCategoryDetail.vue?vue&type=template&id=719f89a9&"
import script from "./ExpenseCategoryDetail.vue?vue&type=script&lang=js&"
export * from "./ExpenseCategoryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports